import { ReactElement } from 'react';
import { Link, Box, SimpleGrid, Text, Stack, Flex, useColorModeValue, Image } from '@chakra-ui/react';

import architecture from '../assets/features_core2_datespot.png'
import animations from '../assets/features_animation.gif'
import renderings from '../assets/features_stills.png'
import handdrawings from '../assets/features_sketch.png'

interface FeatureProps {
    title: string;
    text: string;
    icon: ReactElement;
}

const Feature = ({ title, text, icon }: FeatureProps) => {
    return (
        <Stack>
            <Flex
                align={'center'}
                justify={'center'}
                bg={useColorModeValue('white', 'gray.800')}
                mb={1}
            >
                {icon}
            </Flex>
            <Text fontWeight={'thin'}
                textTransform='uppercase'
                color={useColorModeValue('black', 'white')}
                fontSize={'lg'}
                textAlign='center'
                letterSpacing={1}
            >{title}</Text>
            <Text
                color={useColorModeValue('gray.800', 'gray.200')}
                textAlign='center'
                fontSize={{ base: 'sm', lg: 'sm' }}
            >{text}
            </Text>
        </Stack>
    );
};

export default function Summary() {
    return (
        <Box mt={{ base: 10, md: 20 }}
            mx={'16px'}
        >
            <Text
                textAlign={['left', 'center']}
                pb={8}
                fontSize='4xl'
                letterSpacing={2}
                color={useColorModeValue('black', 'white')}
                fontWeight='thin'
                textTransform='uppercase'
                lineHeight='1'
            >
            </Text>
            <SimpleGrid columns={{ base: 2, md: 4 }} spacing={6}>
                <Feature
                    icon={
                        <Image
                            src={architecture}
                            alt='architecture'
                            w={80}
                            rounded={'2xl'}
                            boxShadow={'2xl'}
                        />
                    }
                    title={'Architecture'}
                // text={
                // }
                />

                <Feature
                    icon={<Image
                        src={animations}
                        alt='animations'
                        w={80}
                        rounded={'2xl'}
                        boxShadow={'2xl'}
                    />}
                    title={'Animations'}
                // text={
                //     'Bringing life to designs'
                // }
                />
                <Link href='/#renderings'>
                <Feature
                    icon={<Image
                        src={renderings}
                        alt='renderings'
                        w={80}
                        rounded={'2xl'}
                        boxShadow={'2xl'} />}
                    title={'Renderings'}
                // text={
                //     'Sprints and studies in a variety of media'
                // }
                />
                </Link>
                <Link href='/#handdrawings'>
                    <Feature
                        icon={<Image
                            src={handdrawings}
                            alt='hand drawings'
                            w={80}
                            rounded={'2xl'}
                            boxShadow={'2xl'}
                        />}
                        title={'Hand Drawings'}
                    // text={
                    //     'Le Grand Tour 2018-2019, Reflections 2023'
                    // }
                    />
                </Link>
            </SimpleGrid>
        </Box>
    );
}